
import { createSelector } from '@ngrx/store';
import { selectVistaUsuario, VistaUsuarioState } from '../../vista-usuario/vista-usuario.state';
import { EntityEspeciesCertificablesAdapter, EntityEspeciesCertificablesState } from './entity-especies-certificables.state';

const { selectEntities, selectAll } = EntityEspeciesCertificablesAdapter.getSelectors();

export const getError = (state: EntityEspeciesCertificablesState): any => state.error;

export const getIsLoading = (state: EntityEspeciesCertificablesState): boolean =>
  state.isLoading;

export const selectEntityEspeciesCertificablesState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.especiesCertificables
);

export const selectAllEntityEspeciesCertificables = createSelector(selectEntityEspeciesCertificablesState, selectAll);
export const selectEntityEspeciesCertificablesEntities = createSelector(
  selectEntityEspeciesCertificablesState,
  selectEntities
);

export const selectEntityEspeciesCertificablesError = createSelector(
  selectEntityEspeciesCertificablesState,
  getError
);

export const selectEntityEspeciesCertificablesIsLoading = createSelector(
  selectEntityEspeciesCertificablesState,
  getIsLoading
);

export const selectEntityEspeciesCertificablesAddedSuccess = createSelector(
  selectEntityEspeciesCertificablesState,
  (state) => state.hasAddedSuccess
);
